import React, { useEffect } from "react";
import Header from "./Header";
import Footer from "./Footer";
import highSlide from "../assets/images/icons/high-slide.svg";
import digitalPath from "../assets/images/icons/digital-path.svg";
import secureOnline from "../assets/images/icons/secure-online.svg";
import expertCons from "../assets/images/icons/expert-cons.svg";
import slideSeminars from "../assets/images/icons/slide-seminars.svg";
import sessionbg from "../assets/images/session-bg.svg";
import ourVision from '../assets/images/ourVision.svg';
import tickIcon from "../assets/images/icons/dia-icon.svg"


const Diagnostics = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <Header />

            <section className="about-us-section ">
                <div className="container">
                    <h3 className="txt-48">Diagnostics</h3>
                    <p className="txt-16">Precision Diagnostics. Lifelong Learning. Global Impact.</p>
                </div>
            </section>

            <section className="learning-hub-section diagnostics-section">
                <div className="we-are_bg">
                    <img src={sessionbg} alt="DADI Logo" width="1130" />
                </div>
                <div className="container py-5">
                    <div className="text-center mb-3">
                        <h3 className="txt-48 ">Empowering Dermatopathology Education Through <br className="d-none d-md-block" /> Innovation and Access</h3>
                        <p className="txt-13">At DADI (Dermpath Academy and Diagnostics India Pvt Ltd), our Diagnostics services are led by experienced dermatopathologists <br className="d-none d-md-block" /> committed to delivering precise and timely skin biopsy interpretations. We combine clinical insights with microscopic<br className="d-none d-md-block" /> expertise to provide actionable diagnostic reports that aid in optimal patient management.</p>

                    </div>

                    <div className="row key-feu-expo">
                        {/* KEY FEATURES */}
                        <div className="col-lg-12">
                            <h4 className="key-feu-txt text-center">Key Features</h4>
                            <div className="row">

                                <div className="col-sm-4 feature-item">
                                    <img src={highSlide} alt="Icon" className="feature-icon"></img>
                                    <div className="feature-text">
                                        <h6>High-Qality Slide Review</h6>
                                        <p>Expert evaluation of H&E and special-stained slides.</p>
                                    </div>
                                </div>

                                <div className="col-sm-4 feature-item">
                                    <img src={digitalPath} alt="Icon" className="feature-icon"></img>
                                    <div className="feature-text">
                                        <h6>Digital Pathology Integration</h6>
                                        <p>Upload and share digital slides for faster turnaround.</p>
                                    </div>
                                </div>

                                <div className="col-sm-4 feature-item">
                                    <img src={secureOnline} alt="Icon" className="feature-icon"></img>
                                    <div className="feature-text">
                                        <h6>Secure Online Access</h6>
                                        <p>Seamlessly submit cases and access reports through our secure online portal.</p>
                                    </div>
                                </div>

                                <div className="col-sm-4 feature-item">
                                    <img src={expertCons} alt="Icon" className="feature-icon"></img>
                                    <div className="feature-text">
                                        <h6>Expert Consultation</h6>
                                        <p>Get detailed diagnostic opinions and clinicopathological correlations to support complex cases.</p>
                                    </div>
                                </div>

                                <div className="col-sm-4 feature-item">
                                    <img src={slideSeminars} alt="Icon" className="feature-icon"></img>
                                    <div className="feature-text">
                                        <h6>Slide Seminars</h6>
                                        <p>Enhance diagnostic precision through digital slide reviews and case interpretations.</p>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <section className="who-we-are-section">
                            <div className="vision-section">
                                <div className="image-container">
                                    <img src={ourVision} alt="Doctors Vision" />
                                </div>
                                <div className="vision-text">
                                    {/* <h3 className="txt-48">Our Vision</h3> */}
                                    Our goal is to bridge clinical practice and pathology expertise,<br className="d-none d-md-block" /> helping healthcare professionals improve diagnostic accuracy and patient outcomes.
                                </div>
                            </div>
                        </section>
                    </div>


                    {/* <div className="mt-2 text-center">
                        <p className="txt-22 end-txt">Our goal is to bridge clinical practice and pathology expertise,<br className="d-none d-md-block" /> helping healthcare professionals improve diagnostic accuracy and patient outcomes.</p>
                    </div> */}

                </div>
            </section>

            <Footer />
        </>
    );
}

export default Diagnostics;
